<template>
  <div id="Aliplayer">
    <div id="J_prismPlayer"></div>
  </div>
</template>

<script>
  import {getPlayAuth, getUserNotOverTaskList, postUserTaskRecord, saveWatchVideoRecord, findProgressValueList} from "@/api";
  import {getUserId, isBrainMedPC} from "@/utils/methods";
  import {yg_video_view} from "@u/AnalysysAgent";
  import Cookie from "js-cookie";
  import {notification} from 'ant-design-vue';

  export default {
    name: "Aliplayer",
    components: {},
    data() {
      return {
        player: {},
        video_o: {
          playauth: '',
          vid: '',
        },
        recordTimer: null, // 时间循环
        courseId: this.$route.query.courseId ? this.$route.query.courseId : this.$route.params.videoId,
        ocsAllPlayTime: null,
        watch_course: [], // 成长体系数据
        pc: [
          {name: "bigPlayButton", align: "cc"},
          {name: "H5Loading", align: "cc"},
          {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
          {name: "infoDisplay"},
          {name: "tooltip", align: "blabs", x: 0, y: 56},
          {name: "thumbnail"},
          {
            name: "controlBar", align: "blabs", x: 0, y: 0,
            children: [
              {name: "progress", align: "blabs", x: 0, y: 44},
              {name: "playButton", align: "tl", x: 15, y: 12},
              {name: "timeDisplay", align: "tl", x: 10, y: 7},
              {name: "fullScreenButton", align: "tr", x: 10, y: 12},
              {name: "setting", align: "tr", x: 15, y: 12},
              {name: "volume", align: "tr", x: 5, y: 10}
            ]
          }
        ],
        // 桌面端
        platform: [
          {name: "bigPlayButton", align: "cc"},
          {name: "H5Loading", align: "cc"},
          {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
          {name: "infoDisplay"},
          {name: "tooltip", align: "blabs", x: 0, y: 56},
          {name: "thumbnail"},
          {
            name: "controlBar", align: "blabs", x: 0, y: 0,
            children: [
              {name: "progress", align: "blabs", x: 0, y: 44},
              {name: "playButton", align: "tl", x: 15, y: 12},
              {name: "timeDisplay", align: "tl", x: 10, y: 7},
              {name: "fullScreenButton", align: "tr", x: 10, y: 12},
              {name: "setting", align: "tr", x: 15, y: 12},
              {name: "volume", align: "tr", x: 5, y: 10}
            ]
          }
        ],
        videoTitle: '',  // 视频标题
        speakerNames: '', // 视频讲者
        videoId: '', // 视频id
        percent: 0, // 视频百分比
        date: new Date(), // 开始时间
      }
    },
    props: ['data_vid', 'data_videoInfo'],
    methods: {
      getPlayer() {
        if (this.player.dispose) {
          // 防止创建两个播放器
          this.player.dispose();
        }
        let bodywidth = document.body.clientWidth; // 屏幕宽度
        let videoheight = (bodywidth * 9) / 16; // 根据宽度计算高度 16:9
        this.player = new Aliplayer({
          id: 'J_prismPlayer',
          width: '100%',
          height: "100%",
          autoplay: true,
          isLive: false,
          showBarTime: '3000',
          controlBarVisibility: "hover",
          useH5Prism: true,
          format: 'm3u8',
          loadDataTimeout: 15,
          defaultDefinition: 'SD',
          // definition:'HD',
          //播放方式二：点播用户推荐
          vid: this.video_o.vid,
          playauth: this.video_o.playauth,
          cover: '',
          "skinLayout": isBrainMedPC() ? this.platform : this.pc
        }, (player) => {
          console.log('播放器创建好了。');
          player.on("error", this.getPlayer);
          this.data_videoInfo.normalCourseVideos.map((v) => {
            if (v.video.vid === this.data_vid) {
              this.videoTitle = v.video.name;
              this.speakerNames = v.video.speakerNames;
              this.videoId = v.video.id;
            }
          })
          this.$store.commit('setPlayer', this.player)
          // 循环添加易观

          clearInterval(this.ocsAllPlayTime);


          player.on("play", () => {
            this.setOcsAllPlayTime();
            this.setVideoView_fn(player);
          });
          player.on("pause", () => {
            this.pauseOcsAllPlayTime();
            // 播放结束上传勋章需要的信息
            this.saveWatchVideoRecord_fn();
            // 关闭易观观看事件
            this.stopVideoView_fn();
          });
          player.on("ended", () => {
            this.pauseOcsAllPlayTime();
            // 播放结束上传勋章需要的信息
            this.saveWatchVideoRecord_fn();
            // 关闭易观观看事件
            this.stopVideoView_fn();
          });
        });
      },

      // 获取用户未完成任务列表
      async getUserNotOverTaskList_fn() {
        this.watch_course = [];
        if (getUserId()) {
          await getUserNotOverTaskList({
            userId: getUserId(),
          }).then(res => {
            console.log('成长体系', res)
            if (res.data.code === 1) {
              res.data.list.map((v) => {
                if (v.taskCode === 'watch_course') {
                  this.watch_course.push(v);
                  if (!this.watch_course.length) {
                    localStorage.removeItem('ocsAllPlayTime_GrowthSys')
                  }
                }
              })
            }
          })
        }
      },

      // 易观观看事件开启
      setVideoView_fn(player){
        clearInterval(this.recordTimer);
        this.recordTimer = setInterval(() => {
          let currentTime = Math.ceil(player.getCurrentTime());
          if (currentTime) {
            yg_video_view(
                'setInterval',
                this.videoId,
                this.courseId,
                this.videoTitle,
                this.speakerNames,
                this.percent,
                this.data_videoInfo.name
            );
          }
        }, 60000)
      },
      // 关闭易观观看事件
      stopVideoView_fn(){
        clearInterval(this.recordTimer);
      },

      async setOcsAllPlayTime() {
        // 获取成长体系信息
        await this.getUserNotOverTaskList_fn();
        // 计时器
        this.ocsAllPlayTime = setInterval(() => {
          let currentTime = Math.ceil(this.player.getCurrentTime());
          let duration = this.player.getDuration();
          // 视频百分比
          this.percent = Math.floor(currentTime / duration * 10000) / 100;
          if (this.percent > 100) {
            this.percent = 100
          }
          // 成长体系 获取条件
          if (this.watch_course.length) {
            this.postUserTaskRecord_fn();
          }
        }, 1000)
      },
      // 暂停事件
      pauseOcsAllPlayTime() {
        console.log('pause');
        clearInterval(this.ocsAllPlayTime);
      },
      // 成长体系
      postUserTaskRecord_fn() {
        let growthSys = [];
        let storage_growthSys = JSON.parse(localStorage.getItem('ocsAllPlayTime_GrowthSys'));
        let nowDate = '' + this.date.getFullYear() + this.date.getMonth() + this.date.getDate();
        this.watch_course.map(v => {
          let duration = 0;
          if (storage_growthSys && storage_growthSys.length) {
            storage_growthSys.map(j => {
              if (v.taskId === j.details.taskId) {
                if (nowDate !== j.date) {
                  j.duration = 0;
                }
                duration = j.duration;
              }
            })
          }
          duration++;
          if (duration >= v.conditionValue) {
            clearInterval(this.ocsAllPlayTime);
            postUserTaskRecord({
              taskId: v.taskId,
              userId: getUserId()
            }).then(res => {
              if (res.code === 1) {
                console.log('提交任务')
                // receiveRewardType：任务奖励领取方式，M：手动领取，A：自动领取
                if (v.receiveRewardType === 'A') {
                  this.$store.commit('setGrowthSys_toast', {
                    rewardValue: v.rewardValue,
                    type: true,
                    date: nowDate
                  })
                }
                this.setOcsAllPlayTime();
              }
            })
          } else {
            growthSys.push({details: v, duration, date: nowDate});
          }
        })
        localStorage.setItem('ocsAllPlayTime_GrowthSys', JSON.stringify(growthSys));
      },
      // 勋章
      saveWatchVideoRecord_fn() {
        if (getUserId() && this.player.getStatus() === 'playing') {
          saveWatchVideoRecord({
            userId: getUserId(),
            videoId: this.videoId,
            progressValue: this.percent,
          }).then(res => {
            console.log('勋章', res)
          })
        }
      },
      // 视频
      getPlayAuth_fn(vid) {
        // 切换视频时,上一个播放器数据还没有改变之前上传上一个视频的勋章信息
        if(this.player.play){
          this.saveWatchVideoRecord_fn()
        }
        if (!vid) {
          return
        }
        getPlayAuth({vid: vid})
          .then(res => {
            this.video_o.playauth = res.data.data.authinfo;
            this.video_o.vid = vid;
            this.getPlayer();
          })
      },
      // 勋章获取视频进度要求值信息
      findProgressValueList_fn(){
        findProgressValueList({
          videoId: this.videoId
        }).then(res=>{
          console.log('勋章节点',res);
        })
      }
    },
    mounted() {
      this.getPlayAuth_fn(this.data_vid);
      window.addEventListener('beforeunload',()=>{
        if(getUserId() && this.player.getStatus() === 'playing'){
          var formData = new FormData()
          formData.append('userId', getUserId())
          formData.append('videoId', this.videoId)
          formData.append('progressValue', this.percent)
          navigator.sendBeacon("/grow/medal/saveWatchVideoRecord.jspx", formData)
        }
      })
    },
    watch: {
      // vid变化
      data_vid: {
        handler(newVid) {
          this.getPlayAuth_fn(newVid); // 获取视频信息
        },
        deep: true
      },
    },
    beforeUnmount() {
      this.saveWatchVideoRecord_fn()
      clearInterval(this.recordTimer);
      clearInterval(this.ocsAllPlayTime);
    },
  }
</script>

<style scoped lang="scss">
  #Aliplayer {
    display: flex;
    width: 100%;
    height: 100%;
  }

  :deep(.prism-info-display) {
    height: 100%;
    top: 0;
    background: rgba(51, 51, 51, 0.2);
  }
</style>
